import { firestoreAction } from 'vuexfire'
import { db } from '@/firebase/db'

/* 

  User levels 
  0 'companyUser' - app 
  1 'companyAdmin' - app, adminpanel 
  2 'glorUser' - app, adminpanel, all companies 
  3 'glorAdmin' app, admin, all companies, grant glor disposal 

*/

const state = {
  data: false,
  inspect: null,
}

const getters = {
  get(state){
    return typeof state.data === 'object' ? state.data[0] : false
  },

  inspect(state){
    return state.inspect
  },

  id(state){
    return state.data.length ? state.data[0].id : false
  },
  
  superAdmin(state){
    return (typeof state.data[0] !== 'undefined' && typeof state.data[0].level !== 'undefined' && state.data[0].level == 'glorAdmin')
  },
  
  level(state){
    if (typeof state.data[0] === 'undefined' || typeof state.data[0].level === 'undefined')
      return 0
    switch(state.data[0].level){
      case 'companyUser': return 0 
      case 'companyAdmin': return 1
      case 'glorUser' : return 2
      case 'glorAdmin' : return 3
      default: return 0
    }
  },
  
  isAdmin: (state, getters) => {
    return getters.level > 1
  }
}

const mutations = {}

const actions = {
  bind: firestoreAction(({ bindFirestoreRef }, email) => {
    // return the promise returned by `bindFirestoreRef`
    return bindFirestoreRef('data', db.collection('users').where('Email', '==', email))
  }),

  inspect: firestoreAction(({ bindFirestoreRef }, id) => {
    // return the promise returned by `bindFirestoreRef`
    return bindFirestoreRef('inspect', db.collection('users').doc(id))
  }),
}


export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}